module.exports = __webpack_public_path__ + "static/logo_scubasociety-92a27bf9d1b07f56455478d9fa60d63f.png";